import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { stationFullSelector } from 'Features/App/Dictionaries/selectors';
import MapWidget from 'Utils/Widgets/Map/Map.Widget';

const defaultStation = {
  latitude: 0,
  longitude: 0,
  name: '-',
  idx: '-',
};

export default function MapWidgetWrapper() {
  const { stationId } = useParams();
  const { station } = useSelector(stationFullSelector(parseInt(stationId, 10)));

  const {
    latitude,
    longitude,
    name,
    idx,
  } = station || defaultStation;

  return (
    <MapWidget
      lat={latitude}
      lng={longitude}
      stationName={name}
      stationIDX={idx}
    />
  );
}
